/*
 * Mips® keeps its own casing.
 *
 * Headings, menu labels, model names and titles are uppercase via CSS, which
 * turned "Mips®" into "MIPS®". This wraps every "Mips" / "Mips®" in visible
 * text in <span class="mips-mark"> (base.css: text-transform: none), including
 * text added later (cart drawer, sticky bar, theme editor re-renders).
 * The whole phrase is kept in one inline <span class="mips-text"> so a flex or
 * grid parent still treats it as a single item (otherwise "F-17 GP " and
 * "Mips®" become separate flex items, lose the space and can be pushed apart).
 * The text itself doesn't change, so textContent reads stay the same.
 * Without JS the words simply stay uppercase.
 */
(function () {
  var MARK = 'mips-mark';
  var WORD = /Mips®?/g;
  var SKIP = /^(SCRIPT|STYLE|TEMPLATE|NOSCRIPT|TEXTAREA|OPTION|OPTGROUP|SELECT|TITLE|INPUT|CANVAS|IFRAME)$/;

  function skip(node) {
    for (var el = node.parentNode; el && el.nodeType === 1; el = el.parentNode) {
      if (SKIP.test(el.nodeName) || el.classList.contains(MARK) || el.isContentEditable) return true;
      if (el.namespaceURI === 'http://www.w3.org/2000/svg') return true;
    }
    return false;
  }

  function wrap(textNode) {
    var text = textNode.nodeValue;
    WORD.lastIndex = 0;
    if (!WORD.test(text) || skip(textNode)) return;
    WORD.lastIndex = 0;
    var frag = document.createElement('span');
    frag.className = 'mips-text';
    var last = 0;
    var match;
    while ((match = WORD.exec(text))) {
      if (match.index > last) frag.appendChild(document.createTextNode(text.slice(last, match.index)));
      var span = document.createElement('span');
      span.className = MARK;
      span.textContent = match[0];
      frag.appendChild(span);
      last = match.index + match[0].length;
    }
    if (last < text.length) frag.appendChild(document.createTextNode(text.slice(last)));
    textNode.parentNode.replaceChild(frag, textNode);
  }

  function scan(root) {
    if (!root) return;
    if (root.nodeType === 3) { wrap(root); return; }
    if (root.nodeType !== 1 && root.nodeType !== 11) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        return n.nodeValue.indexOf('Mips') !== -1 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    var found = [];
    while (walker.nextNode()) found.push(walker.currentNode);
    found.forEach(wrap);
  }

  function start() {
    scan(document.body);
    if (!('MutationObserver' in window)) return;
    var queue = [];
    var scheduled = false;
    new MutationObserver(function (records) {
      records.forEach(function (r) {
        if (r.type === 'characterData') { queue.push(r.target); return; }
        r.addedNodes.forEach(function (n) {
          if (!(n.nodeType === 1 && n.classList.contains(MARK))) queue.push(n);
        });
      });
      if (scheduled || !queue.length) return;
      scheduled = true;
      Promise.resolve().then(function () {
        var batch = queue;
        queue = [];
        scheduled = false;
        batch.forEach(function (n) { if (n.isConnected) scan(n); });
      });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* ---- Light/dark toggle (was assets/color-mode.js; lives here because this file loads on every page anyway) ---- */
/* Light/dark toggle (2026-09-29). The first paint is handled by the inline script in layout/theme.liquid (it sets
   data-theme on <html> from the saved choice, else the theme's Default mode). This file wires the buttons:
   toggles the mode, saves it, keeps every [data-color-toggle] label in step and tells other scripts. */
(function () {
  var KEY = 'kabuto-color-mode';
  var root = document.documentElement;
  function current() { return root.getAttribute('data-theme') === 'light' ? 'light' : 'dark'; }
  function sync() {
    var light = current() === 'light';
    document.querySelectorAll('[data-color-toggle]').forEach(function (b) {
      b.setAttribute('aria-pressed', light ? 'true' : 'false');
      b.setAttribute('aria-label', light ? 'Switch to dark theme' : 'Switch to light theme');
    });
    var meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute('content', getComputedStyle(root).getPropertyValue('--kb-bg').trim() || (light ? '#ffffff' : '#000000'));
  }
  function set(mode, save) {
    root.setAttribute('data-theme', mode);
    if (save) { try { localStorage.setItem(KEY, mode); } catch (e) { /* private mode: the choice lasts for this page only */ } }
    sync();
    document.dispatchEvent(new CustomEvent('color-mode:change', { detail: { mode: mode } }));
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-color-toggle]');
    if (b) set(current() === 'light' ? 'dark' : 'light', true);
  });
  // Follow the device while the visitor hasn't chosen and the default is "system".
  if (root.getAttribute('data-theme-default') === 'system' && window.matchMedia) {
    var mq = window.matchMedia('(prefers-color-scheme: light)');
    var onChange = function () {
      var saved = null;
      try { saved = localStorage.getItem(KEY); } catch (e) { /* ignore */ }
      if (saved !== 'light' && saved !== 'dark') set(mq.matches ? 'light' : 'dark', false);
    };
    if (mq.addEventListener) mq.addEventListener('change', onChange);
  }
  sync();
})();
